module.exports = __webpack_public_path__ + "static/media/mount-direct-indirect.5b9870e4.png";